var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.leaveTime)?_c('countdown',{attrs:{"leave-time":_vm.leaveTime,"start-hour":_vm.startHour,"end-hour":_vm.endHour,"end-min":_vm.endMin,"on-countdown-ends":_vm.leaveCall}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }